import React from "react";

export default function DoctorReport() {
  return <div></div>;
}
